<script setup>
  import { Loader } from '@googlemaps/js-api-loader'

  const { facebook, places, twitter } = defineProps({
    facebook: { type: String },
    places: { type: [Object] },
    twitter: { type: String }
  })

  useHead({
    script: [
      {
        async: true,
        crossorigin: 'anonymous',
        defer: true,
        src: 'https://connect.facebook.net/fr_FR/sdk.js#xfbml=1&version=v14.0'
      },
      {
        async: true,
        charset: 'utf-8',
        src: 'https://platform.twitter.com/widgets.js'
      }
    ]
  })

  const mapElement = ref(null)

  onMounted(async () => {
    const gm = new Loader({
      apiKey: 'AIzaSyB2CVzRrLHhI0BKkvKH0eHw88MqXKdkCmk',
      version: 'weekly'
    })
    const { maps } = await gm.load()
    const bounds = new maps.LatLngBounds()
    const map = new maps.Map(mapElement.value, {
      center: new maps.LatLng(places[0].latitude, places[0].longitude),
      mapTypeId: 'roadmap',
      zoom: 11
    })

    places.forEach(p => {
      const marker = new maps.Marker({
        position: new maps.LatLng(p.latitude, p.longitude),
        title: p.city
      })
      bounds.extend(marker.position)

      const info = new maps.InfoWindow({
        content: `<div class="text-center">${p.street ?? ''}${p.street ? '<br />' : ''}${p.postalCode} ${p.city}</div>`,
        maxWidth: 500,
        maxHeight: 500
      })
      maps.event.addListener(marker, 'click', _event => {
        info.open(map, marker)
      })

      marker.setMap(map)
    })

    if (places.length > 1) map.fitBounds(bounds)
  })
</script>

<template>
  <div class="mx-auto max-w-screen-xl px-4 py-16">
    <div class="-m-4 flex flex-wrap items-center justify-evenly">
      <div class="m-4 w-80" v-if="places.length">
        <div class="h-[500px]" ref="mapElement"></div>
      </div>

      <div class="m-4 flex w-80 justify-center" v-if="facebook">
        <div
          class="fb-page w-full"
          :data-href="`https://www.facebook.com/${facebook}`"
          data-tabs="timeline"
          data-height="500"
          data-small-header="false"
          data-hide-cover="false"
          data-show-facepile="true"
        >
          <blockquote class="fb-xfbml-parse-ignore" :cite="`https://www.facebook.com/${facebook}`">
            <a class="flex flex-col items-center" :href="`https://www.facebook.com/${facebook}`" target="_blank">
              <Loading class="mb-4" />
              <div
                class="font-special text-sm font-bold underline decoration-viking-400 decoration-2 underline-offset-4 duration-300 hover:text-viking-500"
              >
                Voir la page Facebook
              </div>
            </a>
          </blockquote>
        </div>
      </div>

      <div class="m-4 w-80" v-if="twitter">
        <a class="twitter-timeline group flex flex-col items-center" data-height="500" :href="`https://twitter.com/${twitter}`" target="_blank">
          <Loading class="mb-4" />
          <div
            class="font-special text-sm font-bold underline decoration-viking-400 decoration-2 underline-offset-4 duration-300 hover:text-viking-500"
          >
            Voir le fil Twitter
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
